import React, { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto'
import LandscapeIcon from '@mui/icons-material/Landscape'
import CamaraOn from './camaraOn'
import { MAX_IMAGE_SIZE_BYTES, MAX_IMAGE_SIZE_MB } from '../../../../Products/components/Dropzone'

const StoryInitial = ({ setImage, isMobile }: { setImage: (image: any) => void; isMobile: boolean }) => {
  const [camaraOn, setCamaraOn] = useState<boolean>(false)
  const [fileError, setFileError] = useState<string>(null)

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    const validTypes = ['image/jpeg', 'image/png', 'image/jpg']
    if (!validTypes.includes(file.type)) {
      setFileError('Solamente podés subir archivos JPG, JPEG o PNG')
      return
    }
    if (file) {
      if (file.size > MAX_IMAGE_SIZE_BYTES) {
        setFileError(`El tamaño máximo de la imagen es de ${MAX_IMAGE_SIZE_MB}MB`)
        return
      }
      setImage(file)
    }
  }

  return (
    <>
      {camaraOn && <CamaraOn setImage={setImage} isMobile={isMobile} />}
      {!camaraOn && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Button
            variant="contained"
            onClick={() => setCamaraOn(true)}
            sx={{
              gap: '10px',
              backgroundColor: 'grey',
              border: '1px solid black',
              '&:hover': {
                backgroundColor: '#d3d3d3'
              }
            }}
          >
            <AddAPhotoIcon />
            <Typography style={{ fontSize: isMobile ? '12px' : '14px' }}>Tomar una foto</Typography>
          </Button>
          <input
            type="file"
            accept="image/jpeg,image/png,image/jpg"
            style={{ display: 'none' }}
            id="file-upload"
            onChange={handleFileChange}
          />
          <label htmlFor="file-upload">
            <Button
              variant="contained"
              sx={{
                gap: '10px',
                backgroundColor: 'grey',
                border: '1px solid black',
                '&:hover': {
                  backgroundColor: '#d3d3d3'
                }
              }}
              component="span"
            >
              <LandscapeIcon />
              <Typography style={{ fontSize: isMobile ? '12px' : '14px' }}>Elegir desde galería</Typography>
            </Button>
          </label>
        </div>
      )}
      {fileError && (
        <Dialog open={fileError !== null} onClose={() => setFileError(null)} maxWidth="lg">
          <DialogTitle>Error en la subida de imagenes</DialogTitle>
          <DialogContent>{fileError}</DialogContent>
          <DialogActions>
            <Button onClick={() => setFileError(null)}>Cerrar</Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  )
}

export default StoryInitial
